import { useQuery } from '@hooks/reactQuery';

import { getRevokedRoles } from '@api/organisations';

import { extractQueryParams } from '@utils/common';

import { IOrganisationDataParams } from '@interfaces/organisation/organisations';
import { IRolesResponse } from '@interfaces/user/user';

import { TUserRoles } from '@enums/common';

import { REVOKED_ROLES } from '@constants/queryKeys';

export const useQueryRevokedRoles = (params: IOrganisationDataParams) => {
	const { organisationId, isActiveQuery } = params;

	const {
		data: revokedRoles,
		isLoading: isLoadingRevokedRoles,
		isFetching: isFetchingRevokedRoles,
	} = useQuery<IRolesResponse[], TUserRoles[]>({
			queryKey: [
				REVOKED_ROLES,
				organisationId,
			],
			queryFn: extractQueryParams(getRevokedRoles),
			enabled: [!!organisationId, isActiveQuery],
			select: (roles) => roles.map(({ name }) => name),
			refetchOnWindowFocus: false,
		},
	);

	return {
		revokedRoles: revokedRoles || [],
		isLoadingRevokedRoles: (organisationId && isActiveQuery)
			? (isLoadingRevokedRoles && isFetchingRevokedRoles) : false,
	};
};
